import axiosInstance from "../../utils/axiosInstance";

const getBlogs = async (url) => {
  const blogs = await axiosInstance.get(url);
  return blogs.data;
};

export default getBlogs;
